import { KYCServiceType } from "consts/kyc";
import type { ID } from "types";
import route from "adapters/merchant-api";

export const enum ApiRouteTypes {
  GetTransactionFilters = 'GetTransactionFilters',
  GetBankSdk = 'GetBankSdk',
  GetToken = 'GetToken',
  GetTransactionById = 'GetTransactionById',
  GetTransactionHistory = 'GetTransactionHistory',
  GetSendExport = 'GetSendExport',
  GetClearExport = 'GetClearExport',
  GetDownloadCSV = 'GetDownloadCSV',
  GetTransactionOrigins = 'GetTransactionOrigins',
  // New API
  // General
  GetConstants = 'GetConstants',
  GetCountries = 'GetCountries',
  GetUsersPreferences = 'GetUsersPreferences',
  PutUsersPreferences = 'PutUsersPreferences',
  GetSettings = 'GetSettings',
  GetPayoutAccounts = 'GetPayoutAccounts',
  GetPayoutCryptoAccounts = 'GetPayoutCryptoAccounts',
  PostSupport = 'PostSupport',
  PostFeedback = 'PostFeedback',
  // Files
  GetFile = 'GetFile',
  PostFile = 'PostFile',
  DeleteFile = 'DeleteFile',
  PostEmailsWhitelist = 'PostEmailsWhitelist',
  GetEmailsWhitelist = 'GetEmailsWhitelist',
  GetTemplateEmailsWhitelist = 'GetTemplateEmailsWhitelist',
  GetTemplateEmailsWhitelistWithoutSdd = 'GetTemplateEmailsWhitelistWithoutSdd',
  // Authentication
  PostLogin = 'PostLogin',
  PostRefreshToken = 'PostRefreshToken',
  PostLogout = 'PostLogout',
  // 2FA
  PostVerify2FA = 'PostVerify2FA',
  PostResend2FACode = 'PostResend2FACode',
  // Forgot password
  PostRecover = 'PostRecover',
  PostNewPassword = 'PostNewPassword',
  // Transactions
  GetTransactions = 'GetTransactions',
  GetEsTransactions = 'GetEsTransactions',
  PingTransactions = 'PingTransactions',
  // Notifications
  GetInNotifications = 'GetInNotifications',
  GetOutNotifications = 'GetOutNotifications',
  // Notiication channels
  GetNotificationChannels = 'GetNotificationChannels',
  // Merchants
  GetMerchants = 'GetMerchants',
  PostMerchant = 'PostMerchant',
  GetMerchantSettings = 'GetMerchantSettings',
  PutMerchantSettings = 'PutMerchantSettings',
  GetMerchantKYCSettings = 'GetMerchantKYCSettings',
  PutMerchantKYCSettings = 'PutMerchantKYCSettings',
  // Merchant pivots
  GetMerchantsNotificationChannelsPivot = 'GetMerchantsNotificationChannelsPivot',
  PutMerchantsNotificationChannelsPivot = 'PutMerchantsNotificationChannelsPivot',
  // Consumers
  GetConsumers = 'GetConsumers',
  PostConsumer = 'PostConsumer',
  GetConsumersBlacklist = 'GetConsumersBlacklist',
  PostConsumersBlacklist = 'PostConsumersBlacklist',
  DeleteConsumersBlacklist = 'DeleteConsumersBlacklist',
  GetImportConsumerBlacklist = 'GetImportConsumerBlacklist',
  PostImportConsumerBlacklist = 'PostImportConsumerBlacklist',
  GetConsumersWhitelist = 'GetConsumersWhitelist',
  PostConsumersWhitelist = 'PostConsumersWhitelist',
  PostImportConsumerWhitelist = 'PostImportConsumerWhitelist',
  GetConsumerByEmailOrId = 'GetConsumerByEmailOrId',
  PutConsumer = 'PutConsumer',
  GetConsumerEmails = 'GetConsumerEmails',
  PutConsumerEmails = 'PutConsumerEmails',
  GetConsumersKYCSettings = 'GetConsumersKYCSettings',
  PostConsumersKYCSettings = 'PostConsumersKYCSettings',
  GetConsumersManualBulkKYCsImportHistoryPivot = 'GetConsumersManualBulkKYCsImportHistoryPivot',
  // Payment methods
  GetPaymentMethods = 'GetPaymentMethods',
  GetMerchantVisibleMethods = 'GetMerchantVisibleMethods',
  PostMerchantVisibleMethods = 'PostMerchantVisibleMethods',
  DeleteMerchantVisibleMethods = 'DeleteMerchantVisibleMethods',
  // Setups
  GetApiDomains = 'GetApiDomains',
  GetSetupsKYCSwitch = 'GetSetupsKYCSwitch',
  PutSetupsKYCSwitch = 'PutSetupsKYCSwitch',
  GetTicketingSystemSwitch = 'GetTicketingSystemMainSwitch',
  PutTicketingSystemSwitch = 'PutTicketingSystemMainSwitch',
  GetTicketingSystemZendeskSwitch = 'GetTicketingSystemZendeskTicketingSwitch',
  PutTicketingSystemZendeskSwitch = 'PutTicketingSystemZendeskTicketingSwitch',
  // Users
  GetUsers = 'GetUsers',
  GetUserById = 'GetUserById',
  PostUser = 'PostUser',
  GetRoles = 'GetRoles',
  // User pivots
  GetUsersMerchants = 'GetUsersMerchants',
  PostUserMerchant = 'PostUserMerchant',
  DeleteUserMerchant = 'DeleteUserMerchant',
  GetUsersMors = 'GetUsersMors',
  PostUserMor = 'PostUserMor',
  DeleteUserMor = 'DeleteUserMor',
  // Merchant Payouts
  GetLedgers = 'GetLedgers',
  GetEsMerchantPayoutFiles = 'GetEsMerchantPayoutFiles',
  GetMerchantPayoutSummaryFiles = 'GetMerchantPayoutSummaryFiles',
  DownloadMerchantPayoutSummaryFiles = 'DownloadMerchantPayoutSummaryFiles',
  GetMerchantPayoutSummaryFilesTransactionsCSV = 'GetMerchantPayoutSummaryFilesTransactionsCSV',
  GetMerchantPayoutFiles = 'GetMerchantPayoutFiles',
  GetMerchantPayoutFilesById = 'GetMerchantPayoutFilesById',
  GetMerchantPayoutCalculations = 'GetMerchantPayoutCalculations',
  GetMerchantPayoutFileTaxCalculations = 'GetMerchantPayoutFileTaxCalculations',
  PostMerchantPayoutFileTaxCalculations = 'PostMerchantPayoutFileTaxCalculations',
  DeleteMerchantPayoutFileTaxCalculations = 'DeleteMerchantPayoutFileTaxCalculations',
  GetTransactionsMerchantPayoutIncrementsPivot = 'GetTransactionsMerchantPayoutIncrementsPivot',
  GetMerchantPayoutIncrementTaxes = 'GetMerchantPayoutIncrementTaxes',
  PostMerchantPayoutIncrementTaxes = 'PostMerchantPayoutIncrementTaxes',
  DeleteMerchantPayoutIncrementTaxes = "DeleteMerchantPayoutIncrementTaxes",
  GetMerchantPayoutIncrements = 'GetMerchantPayoutIncrements',
  PutMerchantPayoutIncrements = 'PutMerchantPayoutIncrements',
  PostMerchantPayoutIncrementTaxesBulk = 'PostMerchantPayoutIncrementTaxesBulk',
  GetMerchantPayoutIncrementExchangeRates = 'GetMerchantPayoutIncrementExchangeRates',
  PostMerchantPayoutIncrementExchangeRates = 'PostMerchantPayoutIncrementExchangeRates',
  DeleteMerchantPayoutIncrementExchangeRates = 'DeleteMerchantPayoutIncrementExchangeRates',
  PostMerchantPayoutIncrementExchangeRatesBulk = 'PostMerchantPayoutIncrementExchangeRatesBulk',
  PostMerchantPayoutFiles = 'PostMerchantPayoutFiles',
  PreviewMerchantPayoutFilesSettlementXLS = 'PreviewMerchantPayoutFilesSettlementXLS',
  GetMerchantPayoutFilesTransactionsCSV = 'GetMerchantPayoutFilesTransactionsCSV',
  GetMerchantPayoutFilesStillPendingSettlementCSV = 'GetMerchantPayoutFilesStillPendingSettlementCSV',
  GenerateMerchantPayoutFilesSettlements = 'GenerateMerchantPayoutFilesSettlements',
  DeleteMerchantPayoutFiles = "DeleteMerchantPayoutFiles",
  PaidMerchantPayoutFiles = "PaidMerchantPayoutFiles",
  PostMerchantPayoutSummaryFiles = 'PostMerchantPayoutSummaryFiles',
  DeleteMerchantPayoutSummaryFiles = 'DeleteMerchantPayoutSummaryFiles',
  GetMerchantsMethodsPivot = 'GetMerchantsMethodsPivot',
  PutMerchantsMethodsPivot = 'PutMerchantsMethodsPivot',
  // KYCs
  GetKycs = 'GetKycs',
  PostKycs = 'PostKycs',
  DeleteKYCs = 'DeleteKYCs',
  PostManualBulkKYCsImportHistory = 'PostManualBulkKYCsImportHistory',
  // Manual Bulk KYCs Import History
  GetManualBulkKYCsImportHistory = 'GetManualBulkKYCsImportHistory',
  // KYC Settings
  GetKYCSettings = 'GetKYCSettings',
  PostKYCSettings = 'PostKYCSettings',
  // ECommerce
  GetOnboardingsUsers = 'GetOnboardingsUsers',
  PostOnboardingsRegister = 'PostOnboardingsRegister',
  PostOnboardingsApplications = 'PostOnboardingsApplications',
  PutOnboardingsApplications = 'PutOnboardingsApplications',
  GetOnboardingsApplications = 'GetOnboardingsApplications',
  GetOnboardingsBusinessInformationSteps = 'GetOnboardingsBusinessInformationSteps',
  PutOnboardingsBusinessInformationSteps = 'PutOnboardingsBusinessInformationSteps',
  PutOnboardingsBillingFinanceSteps = 'PutOnboardingsBillingFinanceSteps',
  GetOnboardingsBillingFinanceSteps = 'GetOnboardingsBillingFinanceSteps',
  PutOnboardingsMediaComplianceSteps = 'PutOnboardingsMediaComplianceSteps',
  GetOnboardingsMediaComplianceSteps = 'GetOnboardingsMediaComplianceSteps',
  GetOnboardingsIdentityVerificationSteps = 'GetOnboardingsIdentityVerificationSteps',
  PutOnboardingsIdentityVerificationSteps = 'PutOnboardingsIdentityVerificationSteps',
  GetOnboardingsPaymentMethodsSteps = 'GetOnboardingsPaymentMethodsSteps',
  PutOnboardingsPaymentMethodsSteps = 'PutOnboardingsPaymentMethodsSteps',
  PutOnboardingsUboIdentities = 'PutOnboardingsUboIdentities',
  DeleteOnboardingsUboIdentities = 'DeleteOnboardingsUboIdentities',
  GetOnboardingsCountries = 'GetOnboardingsCountries',
  GetOnboardingsConstants = 'GetOnboardingsConstants',
  GetOnboardingsPaymentMethods = 'GetOnboardingsPaymentMethods',
  PostOnboardingsFiles = 'PostOnboardingsFiles',
  ResendOnboardingRegistrationVerificationLink = 'ResendOnboardingRegistrationVerificationLink',

  // High Risk Merchant Onboarding
  GetOnboardingsHighRiskBusinessInformationSteps = 'GetOnboardingsHighRiskBusinessInformationSteps',
  PutOnboardingsHighRiskBusinessInformationSteps = 'PutOnboardingsHighRiskBusinessInformationSteps',
  GetOnboardingsHighRiskDirectorsAndShareholdersSteps= 'GetOnboardingsHighRiskDirectorsAndShareholdersSteps',
  PutOnboardingsHighRiskDirectorsAndShareholdersSteps= 'PutOnboardingsHighRiskDirectorsAndShareholdersSteps',
  PutOnboardingsHighRiskShareholderIdentities = 'PutOnboardingsHighRiskShareholderIdentities',
  DeleteOnboardingsHighRiskShareholderIdentities = 'DeleteOnboardingsHighRiskShareholderIdentities',
  GetOnboardingsHighRiskFinancialInformationSteps = 'GetOnboardingsHighRiskFinancialInformationSteps',
  PutOnboardingsHighRiskFinancialInformationSteps = 'PutOnboardingsHighRiskFinancialInformationSteps',
  GetOnboardingsHighRiskComplianceSteps = 'GetOnboardingsHighRiskComplianceSteps',
  PutOnboardingsHighRiskComplianceSteps = 'PutOnboardingsHighRiskComplianceSteps',
  GetOnboardingsHighRiskMarketingWebsiteAndSupportSteps = 'GetOnboardingsHighRiskMarketingWebsiteAndSupportSteps',
  PutOnboardingsHighRiskMarketingWebsiteAndSupportSteps = 'PutOnboardingsHighRiskMarketingWebsiteAndSupportSteps',
  GetOnboardingsHighRiskUploadDocumentsSteps = 'GetOnboardingsHighRiskUploadDocumentsSteps',
  PutOnboardingsHighRiskUploadDocumentsSteps = 'PutOnboardingsHighRiskUploadDocumentsSteps',
  PutOnboardingsHighRiskClientDocuments = 'PutOnboardingsHighRiskClientDocuments',
  DeleteOnboardingsHighRiskClientDocuments = 'DeleteOnboardingsHighRiskClientDocuments'
};

export const ApiRoutes = {
  [ApiRouteTypes.GetTransactionFilters]: '/getTransactionFilters',
  [ApiRouteTypes.GetBankSdk]: (queryString: string) => `/getBankSdk${queryString}`,
  [ApiRouteTypes.GetToken]: '/getToken',
  [ApiRouteTypes.GetTransactionById]: (transactionId: ID) => `/getTransaction/${transactionId}`,
  [ApiRouteTypes.GetSendExport]: (queryString: string) => `/sendExport${queryString}`,
  [ApiRouteTypes.GetClearExport]: '/clearExport',
  [ApiRouteTypes.GetDownloadCSV]: '/downloadCsv',
  [ApiRouteTypes.GetTransactionOrigins]: '/transaction-origins',
  [ApiRouteTypes.GetConsumers]: () => route.merchant(['consumers']),
  [ApiRouteTypes.PostConsumer]: '/consumers',
  [ApiRouteTypes.GetConsumersBlacklist]: '/consumers-blacklist',
  [ApiRouteTypes.PostConsumersBlacklist]: '/consumers-blacklist',
  [ApiRouteTypes.DeleteConsumersBlacklist]: (coreIdOrEmail: ID) =>
    route(['consumers-blacklist', coreIdOrEmail]),
  [ApiRouteTypes.PostConsumersWhitelist]: '/consumers-whitelist',
  [ApiRouteTypes.GetEmailsWhitelist]: (pki: ID, fileKey: string) => route.merchant([
    'emails-whitelist',
    pki,
    'files',
    fileKey
  ]),
  [ApiRouteTypes.GetConsumersWhitelist]: () => route.merchant(['emails-whitelist']),
  [ApiRouteTypes.GetConsumerEmails]: route(['consumer-emails']),
  [ApiRouteTypes.PutConsumerEmails]: (coreId: ID) =>
    route(['consumer-emails', coreId]),
  [ApiRouteTypes.GetConsumerByEmailOrId]: (emailOrId: ID) =>
    route(['consumers', emailOrId]),
  [ApiRouteTypes.GetImportConsumerBlacklist]: '/import-consumer-blacklist',
  [ApiRouteTypes.PostImportConsumerBlacklist]: '/import-consumer-blacklist',
  [ApiRouteTypes.PostImportConsumerWhitelist]: '/import-consumer-whitelist',
  [ApiRouteTypes.PostFile]: '/files',
  [ApiRouteTypes.GetFile]: (fileKey: string) =>
    route.merchant(['files', fileKey]),
  [ApiRouteTypes.DeleteFile]: (fileKey: string) =>
    route(['/files', fileKey]),
  [ApiRouteTypes.PutConsumer]: (coreIdOrEmail: ID) =>
    route(['consumers', coreIdOrEmail]),
  // [ApiRouteTypes.PostSaveUser]: '/saveUser',
  // [ApiRouteTypes.PostUpdateUser]: (userId: ID) => `/updateUser/${userId}`,
  // New API
  // [ApiRouteTypes.GetUser]: (userId: ID) => `/users/${userId}`,
  [ApiRouteTypes.PostLogin]: route(['login']),
  [ApiRouteTypes.PostRefreshToken]: route(['refresh']),
  [ApiRouteTypes.PostLogout]: route(['logout']),
  [ApiRouteTypes.GetConstants]: () => route.merchant(['constants']),
  [ApiRouteTypes.PingTransactions]: (coreId?: string) =>
    route([`/ping-transactions`, coreId]),
  [ApiRouteTypes.GetTransactions]: (coreId?: ID) =>
    route.merchant(['transactions', coreId]),
  [ApiRouteTypes.GetEsTransactions]: () => route.merchant(['es-transactions']),
  [ApiRouteTypes.GetTransactionHistory]: (coreId: ID) =>
    route.merchant(['transactions', coreId, 'histories']),
  [ApiRouteTypes.GetMerchants]: '/merchants',
  [ApiRouteTypes.GetMerchantKYCSettings]: '/merchant-kyc-settings',
  [ApiRouteTypes.PutMerchantKYCSettings]: (
    merchantId: ID,
    kycTypeId: KYCServiceType
  ) => route(['merchant-kyc-settings', [merchantId, kycTypeId].join('_')]),
  [ApiRouteTypes.GetMerchantSettings]: '/merchant-settings',
  [ApiRouteTypes.PutMerchantSettings]: (coreId: ID) =>
    route(['merchant-settings', coreId]),
  [ApiRouteTypes.GetMerchantsNotificationChannelsPivot]: '/merchants-notification-channels-pivot',
  [ApiRouteTypes.PutMerchantsNotificationChannelsPivot]: (
    merchantId: ID,
    notificationChannelId: ID
  ) =>
    route(['merchants-notification-channels-pivot', [merchantId, notificationChannelId].join('_')]),
  [ApiRouteTypes.GetConsumersKYCSettings]: '/consumer-kyc-settings',
  [ApiRouteTypes.PostConsumersKYCSettings]: '/consumer-kyc-settings',
  [ApiRouteTypes.GetKYCSettings]: '/kyc-settings',
  [ApiRouteTypes.PostKYCSettings]: (merchantId?: ID) => route(['kyc-settings', merchantId]),
  [ApiRouteTypes.PostMerchant]: (merchantId?: ID) => route(['/merchants', merchantId]),
  [ApiRouteTypes.GetPaymentMethods]: () => route.merchant(['payment-methods']),
  [ApiRouteTypes.GetApiDomains]: '/setups/APIINFO_DOMAINS',
  [ApiRouteTypes.GetInNotifications]: '/notifications-in-history',
  [ApiRouteTypes.GetOutNotifications]: '/notifications-out-history',
  [ApiRouteTypes.GetNotificationChannels]: '/notification-channels',
  [ApiRouteTypes.GetCountries]: () => route.merchant(['countries']),
  [ApiRouteTypes.GetUserById]: (userId: ID) => route.merchant(['users', userId]),
  [ApiRouteTypes.GetUsers]: () => route.merchant(['users']),
  [ApiRouteTypes.PostUser]: (userId?: ID) => route.merchant(['users', userId]),
  [ApiRouteTypes.GetRoles]: () => route.merchant(['roles']),
  [ApiRouteTypes.GetUsersMerchants]: (userId?: ID) => '',
  // route(['/users-merchants-pivot', `?userId[in][]=${userId}`], ''),
  [ApiRouteTypes.GetUsersMors]: (userId?: ID) => '',
  // route(['/users-mors-pivot', `?userId[in][]=${userId}`], ''),
  [ApiRouteTypes.PostUserMerchant]: '/users-merchants-pivot',
  [ApiRouteTypes.DeleteUserMerchant]: (merchantId: ID, userId: ID) =>
    route(['/users-merchants-pivot', `${merchantId}_${userId}`]),
  [ApiRouteTypes.PostUserMor]: '/users-mors-pivot',
  [ApiRouteTypes.DeleteUserMor]: (MOR: string, userId: ID) =>
    route(['/users-mors-pivot', `${MOR}_${userId}`]),
  // Merchant Payouts
  [ApiRouteTypes.GetEsMerchantPayoutFiles]: () => route.merchant(['es-merchant-payout-files']),
  [ApiRouteTypes.GetLedgers]: () => route.merchant(['ledgers']),
  [ApiRouteTypes.GetMerchantPayoutSummaryFiles]: () => route.merchant(['merchant-payout-summary-files']),
  [ApiRouteTypes.DownloadMerchantPayoutSummaryFiles]: (coreId: ID, fileKey: string) =>
    route.merchant(['merchant-payout-summary-files', coreId, 'files', fileKey]),
  [ApiRouteTypes.PostMerchantPayoutSummaryFiles]: "/merchant-payout-summary-files",
  [ApiRouteTypes.GetMerchantPayoutSummaryFilesTransactionsCSV]: (coreId?: ID) =>
    route.merchant(['merchant-payout-summary-file-csv-transactions', coreId]),
  [ApiRouteTypes.GetMerchantPayoutFiles]: () => route.merchant(['merchant-payout-files']),
  [ApiRouteTypes.GetMerchantPayoutFilesById]: (coreId: ID, fileKey?: string) =>
    route.merchant(['merchant-payout-files', coreId, 'files', fileKey]),
  [ApiRouteTypes.PostMerchantPayoutFiles]: "/merchant-payout-files",
  [ApiRouteTypes.GetMerchantPayoutCalculations]: '/merchant-payout-calculations',
  [ApiRouteTypes.GetMerchantPayoutFileTaxCalculations]: '/merchant-payout-file-tax-calculations',
  [ApiRouteTypes.PostMerchantPayoutFileTaxCalculations]: (coreId?: ID) =>
    route(['/merchant-payout-file-tax-calculations', coreId]),
  [ApiRouteTypes.DeleteMerchantPayoutFileTaxCalculations]: (coreId: ID) =>
    route(['/merchant-payout-file-tax-calculations', coreId]),
  [ApiRouteTypes.GetTransactionsMerchantPayoutIncrementsPivot]: '/transactions-merchant-payout-increments-pivot',
  [ApiRouteTypes.GetMerchantPayoutIncrementTaxes]: () => route.merchant(['merchant-payout-increment-taxes']),
  [ApiRouteTypes.PostMerchantPayoutIncrementTaxes]: '/merchant-payout-increment-taxes',
  [ApiRouteTypes.PostMerchantPayoutIncrementTaxesBulk]: '/import-merchant-payout-increment-taxes',
  [ApiRouteTypes.DeleteMerchantPayoutIncrementTaxes]: (coreId?: ID) =>
    route(['/merchant-payout-increment-taxes', coreId]),
  [ApiRouteTypes.GetMerchantPayoutIncrements]: '/merchant-payout-increments',
  [ApiRouteTypes.PutMerchantPayoutIncrements]: (coreId: ID) =>
    route(['/merchant-payout-increments', coreId]),
  [ApiRouteTypes.GetMerchantPayoutIncrementExchangeRates]: '/merchant-payout-increment-exchange-rates',
  [ApiRouteTypes.PostMerchantPayoutIncrementExchangeRates]: '/merchant-payout-increment-exchange-rates',
  [ApiRouteTypes.DeleteMerchantPayoutIncrementExchangeRates]: (coreId?: ID) =>
    route(['/merchant-payout-increment-exchange-rates', coreId]),
  [ApiRouteTypes.PostMerchantPayoutIncrementExchangeRatesBulk]: '/import-merchant-payout-increment-exchange-rates',
  [ApiRouteTypes.GetMerchantPayoutFilesTransactionsCSV]: (coreId?: ID) =>
    route.merchant(['merchant-payout-file-csv-transactions', coreId]),
  [ApiRouteTypes.GetMerchantPayoutFilesStillPendingSettlementCSV]: (coreId?: ID) =>
    route.merchant(['merchant-payout-file-csv-pending-settlement-transactions', coreId]),
  [ApiRouteTypes.GenerateMerchantPayoutFilesSettlements]: (coreId?: ID) =>
    route(['/merchant-payout-files', coreId]),
  [ApiRouteTypes.DeleteMerchantPayoutFiles]: (coreId?: ID) =>
    route(['/merchant-payout-files', coreId]),
  [ApiRouteTypes.PaidMerchantPayoutFiles]: (coreId?: ID) =>
    route(['/merchant-payout-files', coreId]),
  [ApiRouteTypes.PreviewMerchantPayoutFilesSettlementXLS]: (coreId?: ID, MOR?: string) =>
    route(['/settlement-sheet-merchant-payout-files', `${coreId}?MOR=${MOR}`]),
  [ApiRouteTypes.DeleteMerchantPayoutSummaryFiles]: (coreId: ID) =>
    route(['/merchant-payout-summary-files', coreId]),
  [ApiRouteTypes.GetMerchantsMethodsPivot]: '/merchants-methods-pivot',
  [ApiRouteTypes.PutMerchantsMethodsPivot]: (coreId: ID) =>
    route(['merchants-methods-pivot', coreId]),
  [ApiRouteTypes.GetSetupsKYCSwitch]: '/setups/KYC_ON_OFF_SWITCH',
  [ApiRouteTypes.PutSetupsKYCSwitch]: '/setups/KYC_ON_OFF_SWITCH',
  [ApiRouteTypes.GetTicketingSystemSwitch]: '/setups/TICKETING_ON_OFF_SWITCH',
  [ApiRouteTypes.PutTicketingSystemSwitch]: '/setups/TICKETING_ON_OFF_SWITCH',
  [ApiRouteTypes.GetTicketingSystemZendeskSwitch]: '/setups/ZENDESK_TICKETING_ON_OFF_SWITCH',
  [ApiRouteTypes.PutTicketingSystemZendeskSwitch]: '/setups/ZENDESK_TICKETING_ON_OFF_SWITCH',
  [ApiRouteTypes.GetKycs]: '/kycs',
  [ApiRouteTypes.PostKycs]: '/kycs',
  [ApiRouteTypes.DeleteKYCs]: (pki: string) => route(['/kycs', pki]),
  [ApiRouteTypes.GetUsersPreferences]: (userId: ID) => route.merchant(['users-preferences', userId]),
  [ApiRouteTypes.PutUsersPreferences]: (userId: ID) => route.merchant(['users-preferences', userId]),
  [ApiRouteTypes.GetManualBulkKYCsImportHistory]: '/manual-bulk-kycs-import-history',
  [ApiRouteTypes.PostManualBulkKYCsImportHistory]: '/manual-bulk-kycs-import-history',
  [ApiRouteTypes.GetConsumersManualBulkKYCsImportHistoryPivot]: '/consumers-manual-bulk-kycs-import-history-pivot',
  [ApiRouteTypes.GetSettings]: () => route.merchant(['settings']),
  [ApiRouteTypes.GetPayoutAccounts]: () => route.merchant(['payout-accounts']),
  [ApiRouteTypes.GetPayoutCryptoAccounts]: () => route.merchant(['payout-crypto-accounts']),
  [ApiRouteTypes.PostSupport]: () => route.merchant(['support']),
  [ApiRouteTypes.PostFeedback]: () => route.merchant(['feedback']),
  [ApiRouteTypes.PostVerify2FA]: route(['verify']),
  [ApiRouteTypes.PostResend2FACode]: route(['resend-2fa-code']),
  [ApiRouteTypes.PostRecover]: '/recover',
  [ApiRouteTypes.PostNewPassword]: '/new-password',
  [ApiRouteTypes.PostEmailsWhitelist]: () => route.merchant(['emails-whitelist']),
  [ApiRouteTypes.GetTemplateEmailsWhitelist]: () => route.merchant(['template-emails-whitelist']),
  [ApiRouteTypes.GetTemplateEmailsWhitelistWithoutSdd]: () => route.merchant(['template-emails-whitelist-without-sdd']),
  [ApiRouteTypes.GetOnboardingsUsers]: (userId: ID) => route.onboarding(['users', userId]),
  [ApiRouteTypes.PostOnboardingsRegister]: route.onboarding(['register']),
  [ApiRouteTypes.PostOnboardingsApplications]: (userId: ID) => route.onboarding([userId, 'applications']),
  [ApiRouteTypes.PutOnboardingsApplications]: (userId: ID) => route.onboarding([userId, 'applications', userId]),
  [ApiRouteTypes.GetOnboardingsApplications]: (userId: ID) => route.onboarding([userId, 'applications', userId]),
  [ApiRouteTypes.PutOnboardingsBusinessInformationSteps]: (userId: ID) => route.onboarding([userId, 'business-information-steps', userId]),
  [ApiRouteTypes.GetOnboardingsBusinessInformationSteps]: (userId: ID) => route.onboarding([userId, 'business-information-steps', userId]),
  [ApiRouteTypes.GetOnboardingsHighRiskBusinessInformationSteps]: (userId: ID) => route.onboarding([userId, 'client-business-information-steps', userId]),
  [ApiRouteTypes.PutOnboardingsHighRiskBusinessInformationSteps]: (userId: ID) => route.onboarding([userId, 'client-business-information-steps', userId]),
  [ApiRouteTypes.GetOnboardingsHighRiskDirectorsAndShareholdersSteps]: (userId: ID) => route.onboarding([userId, 'client-directors-shareholders-steps', userId]),
  [ApiRouteTypes.PutOnboardingsHighRiskDirectorsAndShareholdersSteps]: (userId: ID) => route.onboarding([userId, 'client-directors-shareholders-steps', userId]),
  [ApiRouteTypes.GetOnboardingsHighRiskFinancialInformationSteps]: (userId: ID) => route.onboarding([userId, 'client-financial-information-steps', userId]),
  [ApiRouteTypes.PutOnboardingsHighRiskFinancialInformationSteps]: (userId: ID) => route.onboarding([userId, 'client-financial-information-steps', userId]),
  [ApiRouteTypes.GetOnboardingsHighRiskComplianceSteps]: (userId: ID) => route.onboarding([userId, 'client-risk-compliance-steps', userId]),
  [ApiRouteTypes.PutOnboardingsHighRiskComplianceSteps]: (userId: ID) => route.onboarding([userId, 'client-risk-compliance-steps', userId]),
  [ApiRouteTypes.GetOnboardingsHighRiskMarketingWebsiteAndSupportSteps]: (userId: ID) => route.onboarding([userId, 'client-marketing-support-steps', userId]),
  [ApiRouteTypes.PutOnboardingsHighRiskMarketingWebsiteAndSupportSteps]: (userId: ID) => route.onboarding([userId, 'client-marketing-support-steps', userId]),
  [ApiRouteTypes.GetOnboardingsHighRiskUploadDocumentsSteps]: (userId: ID) => route.onboarding([userId, 'client-documents-steps', userId]),
  [ApiRouteTypes.PutOnboardingsHighRiskUploadDocumentsSteps]: (userId: ID) => route.onboarding([userId, 'client-documents-steps', userId]),
  [ApiRouteTypes.PutOnboardingsBillingFinanceSteps]: (userId: ID) => route.onboarding([userId, 'billing-finance-steps', userId]),
  [ApiRouteTypes.GetOnboardingsBillingFinanceSteps]: (userId: ID) => route.onboarding([userId, 'billing-finance-steps', userId]),
  [ApiRouteTypes.PutOnboardingsMediaComplianceSteps]: (userId: ID) => route.onboarding([userId, 'media-compliance-steps', userId]),
  [ApiRouteTypes.GetOnboardingsMediaComplianceSteps]: (userId: ID) => route.onboarding([userId, 'media-compliance-steps', userId]),
  [ApiRouteTypes.PutOnboardingsIdentityVerificationSteps]: (userId: ID) => route.onboarding([userId, 'identity-verification-steps', userId]),
  [ApiRouteTypes.GetOnboardingsIdentityVerificationSteps]: (userId: ID) => route.onboarding([userId, 'identity-verification-steps', userId]),
  [ApiRouteTypes.GetOnboardingsPaymentMethodsSteps]: (userId: ID) => route.onboarding([userId, 'payment-methods-steps', userId]),
  [ApiRouteTypes.PutOnboardingsPaymentMethodsSteps]: (userId: ID) => route.onboarding([userId, 'payment-methods-steps', userId]),
  [ApiRouteTypes.PutOnboardingsUboIdentities]: (userId: ID, uboIdentity?: ID) => route.onboarding([userId, 'ubo-identities', uboIdentity]),
  [ApiRouteTypes.DeleteOnboardingsUboIdentities]: (userId: ID, identityId: ID) => route.onboarding([userId, 'ubo-identities', identityId]),
  [ApiRouteTypes.PutOnboardingsHighRiskShareholderIdentities]: (userId: ID, shareholderIdentityId?: ID) => route.onboarding([userId, 'client-other-people', shareholderIdentityId]),
  [ApiRouteTypes.DeleteOnboardingsHighRiskShareholderIdentities]: (userId: ID, shareholderIdentityId: ID) => route.onboarding([userId, 'client-other-people', shareholderIdentityId]),
  [ApiRouteTypes.PutOnboardingsHighRiskClientDocuments]: (userId: ID, clientDocumentId?: ID) => route.onboarding([userId, 'client-documents', clientDocumentId]),
  [ApiRouteTypes.DeleteOnboardingsHighRiskClientDocuments]: (userId: ID, clientDocumentId: ID) => route.onboarding([userId, 'client-documents', clientDocumentId]),
  [ApiRouteTypes.GetOnboardingsCountries]: () => route.onboarding(['countries']),
  [ApiRouteTypes.GetOnboardingsConstants]: () => route.onboarding(['constants']),
  [ApiRouteTypes.GetOnboardingsPaymentMethods]: () => route.onboarding(['payment-methods']),
  [ApiRouteTypes.PostOnboardingsFiles]: () => route.onboarding(['files']),
  [ApiRouteTypes.GetMerchantVisibleMethods]: () => route.merchant(['merchant-visible-methods']),
  [ApiRouteTypes.PostMerchantVisibleMethods]: () => route.merchant(['merchant-visible-methods']),
  [ApiRouteTypes.DeleteMerchantVisibleMethods]: (coreId: ID) => route.merchant(['merchant-visible-methods', coreId]),
  [ApiRouteTypes.ResendOnboardingRegistrationVerificationLink]: route.onboarding(['resend-verification-email']),
};
